module.exports = (__parcel__import__("iMSmt")).then(() => parcelRequire('2geSQ'));